export enum PalantirTextTypeEnum {
  description = 'description',
  disabled = 'disabled',
  negative = 'negative',
  primary = 'primary',
  'primary-bold' = 'primary-bold',
  subtitle = 'subtitle',
  text = 'text',
  title = 'title',
  warning = 'warning',
  white = 'white',
}

export type PalantirTextType = keyof typeof PalantirTextTypeEnum;
